import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;
`;

export const KidsDetailModalContainer = styled.div`
  padding: 15px 2rem 2rem;
  width: 760px;
  max-width: 95%;
`;

//////////////////////////////////////////////

export const KidBoxTitleMargin = styled.span`
  margin-bottom: ${({ theme }) => theme.spacing.x4};
  font-size: ${({ theme }) => theme.fs.md};
`;

const InputWrapper = styled.div`
  margin: -${({ theme }) => theme.spacing.x2};
  display: flex;
  flex-wrap: wrap;
`;

export const KidFormInputWrapper = styled(InputWrapper)`
  > * {
    padding: ${({ theme }) => theme.spacing.x2};
    width: 33.333%;
    @media (max-width: ${({ theme }) => theme.media.sm}) {
      width: 50%;
    }
    @media (max-width: ${({ theme }) => theme.media.xs}) {
      width: 100%;
    }
  }
`;

export const TextFieldKid = styled.div`
  /* width: 50% !important; */
`;
